var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_273_5318)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_273_5318)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 16.5,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75 42.3333V45.2718C67.2814 45.2257 66.781 45.196 66.25 45.1789V42.3333C66.25 39.6858 65.882 37.3429 64.4837 35.669C63.0683 33.9747 60.7021 33.0833 57 33.0833C53.2979 33.0833 50.9317 33.9747 49.5163 35.669C48.118 37.3429 47.75 39.6858 47.75 42.3333V45.1789C47.219 45.196 46.7186 45.2257 46.25 45.2718V42.3333C46.25 39.9379 46.544 37.2591 48.0028 35.1834C49.4362 33.1439 52.072 31.5833 57 31.5833C61.928 31.5833 64.5638 33.1439 65.9972 35.1834C67.4561 37.2591 67.75 39.9379 67.75 42.3333Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1826 46.3287L68.1826 46.3288L68.1898 46.3297C70.2435 46.5793 71.4231 47.1901 72.1315 48.2931C72.8694 49.442 73.1668 51.2228 73.1668 54V57.3333C73.1668 60.6702 72.7376 62.5554 71.6466 63.6464C70.5556 64.7374 68.6704 65.1667 65.3335 65.1667H48.6668C45.3299 65.1667 43.4447 64.7374 42.3537 63.6464C41.2627 62.5554 40.8335 60.6702 40.8335 57.3333V54C40.8335 51.2228 41.1309 49.442 41.8688 48.2931C42.5772 47.1901 43.7568 46.5793 45.8105 46.3297L45.8105 46.3297L45.8177 46.3287C46.5235 46.2325 47.3341 46.1832 48.2546 46.1667H65.7457C66.6662 46.1832 67.4769 46.2325 68.1826 46.3287ZM51.8607 57.213L51.8705 57.2037L51.8798 57.1939C52.2618 56.7906 52.5002 56.2364 52.5002 55.6667C52.5002 55.3741 52.433 55.0922 52.3284 54.841C52.2226 54.5871 52.0749 54.356 51.8885 54.1488L51.8797 54.1391L51.8704 54.1298C51.2639 53.5233 50.3176 53.3263 49.5111 53.6704C49.2262 53.7815 49.0109 53.936 48.8157 54.1117L48.7961 54.1293L48.7785 54.1488C48.5921 54.356 48.4444 54.5871 48.3386 54.841C48.234 55.0922 48.1668 55.3741 48.1668 55.6667C48.1668 56.2364 48.4052 56.7906 48.7872 57.1939L48.8009 57.2083L48.8157 57.2216C49.0116 57.3979 49.2278 57.5529 49.5142 57.6641C49.7637 57.7673 50.0434 57.8333 50.3335 57.8333C50.9032 57.8333 51.4575 57.595 51.8607 57.213ZM58.5274 57.213L58.5418 57.1993L58.5551 57.1845C58.7416 56.9773 58.8892 56.7462 58.995 56.4923C59.0997 56.2412 59.1668 55.9592 59.1668 55.6667C59.1668 55.0777 58.9266 54.5407 58.5465 54.1395L58.5395 54.1321L58.5323 54.1251C57.7075 53.322 56.2778 53.3153 55.4633 54.1298L55.4631 54.1296L55.4539 54.1395C55.0737 54.5407 54.8335 55.0777 54.8335 55.6667C54.8335 55.9592 54.9006 56.2412 55.0053 56.4923C55.1111 56.7462 55.2587 56.9773 55.4452 57.1845L55.4585 57.1993L55.473 57.213C55.8742 57.5931 56.4113 57.8333 57.0002 57.8333C57.5699 57.8333 58.1241 57.595 58.5274 57.213ZM65.194 57.213L65.2038 57.2037L65.2131 57.1939C65.5951 56.7906 65.8335 56.2364 65.8335 55.6667C65.8335 55.5303 65.8124 55.3831 65.7972 55.2774L65.7951 55.2626L65.7953 55.2626L65.7934 55.2511C65.7696 55.1087 65.7248 54.9718 65.6627 54.8412C65.6168 54.7133 65.5493 54.5786 65.4551 54.4561C65.3801 54.3453 65.3063 54.2531 65.2445 54.1758L65.2406 54.171L65.2233 54.1494L65.2037 54.1298C64.3892 53.3153 62.9595 53.322 62.1347 54.1251L62.1275 54.1321L62.1205 54.1395C61.7404 54.5407 61.5002 55.0777 61.5002 55.6667C61.5002 56.2556 61.7404 56.7926 62.1205 57.1939L62.1298 57.2037L62.1396 57.213C62.5429 57.595 63.0971 57.8333 63.6668 57.8333C64.2365 57.8333 64.7908 57.595 65.194 57.213Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_273_5318",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_5318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_5318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_5318",
    x1: 25,
    y1: 17,
    x2: 89,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLock);
export default __webpack_public_path__ + "static/media/AuthLock.13fe9db5bee77dae7a38b2ef35dad769.svg";
export { ForwardRef as ReactComponent };